import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import CancelIcon from "@mui/icons-material/Cancel";

const iconMap = {
  free: { Icon: CheckCircleIcon, color: "#4caf50" },
  partial: { Icon: WatchLaterIcon, color: "#ff9800" },
  busy: { Icon: CancelIcon, color: "#f44336" },
};

export const StatusBadge = ({ status }) => {
  const config = iconMap[status];
  if (!config) return null;
  const { Icon, color } = config;
  return <Icon sx={{ fontSize: 20, color }} />;
};
